// extracted by mini-css-extract-plugin
export default {"button":"YwDqeAPpoqM0SA7OwVuT","primary":"dIpWTKybt2EmOyGdSSTU","secondary":"fe9MPEJhbYt0rWjtZbIh","fade-in":"vyzCnI3ScB3TfNBIxcL6"};